import { Head, Link } from "@inertiajs/react"
import { Header } from "@/components/header"

export default function Dmca() {
  return (
    <div className="min-h-screen">
      <Head title="DMCA Policy" />
      <Header />

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <h1 className="text-2xl font-mono font-bold mb-8">DMCA POLICY</h1>

        <div className="prose prose-invert prose-sm max-w-none space-y-8">
          <p className="text-muted-foreground">
            Last updated: January 2026
          </p>

          <section>
            <h2 className="text-lg font-mono font-bold mb-3">Overview</h2>
            <p className="text-muted-foreground leading-relaxed">
              Broken Sounds respects the intellectual property rights of others and expects our
              users to do the same. In accordance with the Digital Millennium Copyright Act
              ("DMCA"), we will respond to valid notices of alleged copyright infringement.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-mono font-bold mb-3">Filing a DMCA Takedown Notice</h2>
            <div className="text-muted-foreground leading-relaxed space-y-3">
              <p>
                If you believe that content on Broken Sounds infringes your copyright, please send
                a written notification to our designated agent containing the following information:
              </p>
              <ol className="list-decimal list-inside space-y-2 ml-2">
                <li>
                  A physical or electronic signature of the copyright owner or a person authorized
                  to act on their behalf
                </li>
                <li>
                  Identification of the copyrighted work claimed to have been infringed
                </li>
                <li>
                  Identification of the material that is claimed to be infringing, including the
                  URL or other specific location on our site
                </li>
                <li>
                  Your contact information, including name, address, telephone number, and email address
                </li>
                <li>
                  A statement that you have a good faith belief that use of the material is not
                  authorized by the copyright owner, its agent, or the law
                </li>
                <li>
                  A statement, under penalty of perjury, that the information in your notice is
                  accurate and that you are authorized to act on behalf of the copyright owner
                </li>
              </ol>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-mono font-bold mb-3">Designated Agent</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">
                Send DMCA notices to:
              </p>
              <div className="bg-muted/30 p-4 rounded font-mono text-sm">
                <p>Email: <a href="mailto:admin@brokensounds.net" className="text-primary hover:underline">admin@brokensounds.net</a></p>
                <p className="mt-1">Subject line: DMCA Takedown Notice</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-mono font-bold mb-3">Counter-Notification</h2>
            <div className="text-muted-foreground leading-relaxed space-y-3">
              <p>
                If you believe your content was removed in error, you may submit a counter-notification
                containing:
              </p>
              <ol className="list-decimal list-inside space-y-2 ml-2">
                <li>Your physical or electronic signature</li>
                <li>
                  Identification of the material that was removed and the location where it appeared
                  before removal
                </li>
                <li>
                  A statement under penalty of perjury that you have a good faith belief the material
                  was removed as a result of mistake or misidentification
                </li>
                <li>
                  Your name, address, and telephone number, and a statement that you consent to the
                  jurisdiction of the federal court in your district
                </li>
              </ol>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-mono font-bold mb-3">Response Process</h2>
            <div className="text-muted-foreground leading-relaxed space-y-3">
              <p>Upon receiving a valid DMCA notice:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>We will remove or disable access to the allegedly infringing content</li>
                <li>We will notify the user who uploaded the content</li>
                <li>The user may submit a counter-notification</li>
                <li>
                  If a valid counter-notification is received, we may restore the content after
                  10-14 business days unless we receive notice that legal action has been filed
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-mono font-bold mb-3">Repeat Infringers</h2>
            <p className="text-muted-foreground leading-relaxed">
              In appropriate circumstances, we will terminate the accounts of users who are repeat
              infringers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-mono font-bold mb-3">Good Faith</h2>
            <p className="text-muted-foreground leading-relaxed">
              Please note that submitting a false DMCA notice may result in legal liability. Consult
              with an attorney if you are unsure whether material infringes your copyright.
            </p>
          </section>

          <div className="pt-4 border-t border-border">
            <p className="text-muted-foreground">
              See also our{" "}
              <Link href="/terms" className="text-primary hover:underline">
                Terms of Service
              </Link>
              {" and "}
              <Link href="/privacy" className="text-primary hover:underline">
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}
